module.exports = __webpack_public_path__ + "static/img/badge-trap-scheduled-irregular.6fb6a1f.svg";